<template>
  <div
    class="discord-box"
    :class="{ 'discord-box-compact': compact }"
    @keydown.enter="saveTag"
  >
    <div class="discord-box_content">
      <div class="discord-box_header">
        <v-icon
          v-if="!discord_tag"
          class="discord-box_icon clr-primary"
          >mdi-discord</v-icon
        >
        <div class="discord-box_text">
          <span v-if="!discord_tag">
            <TooltipUnderline :text="$t('subscription.activate_discord_tooltip')">
              <span v-html="$t('subscription.activate_sub_role_on_discord_0')"></span>
            </TooltipUnderline>
          </span>
          <span v-if="!discord_tag">
            {{ $t('subscription.activate_sub_role_on_discord_1') }} &nbsp;</span
          >
          <a
            v-if="!discord_tag"
            :href="links_url_links.discord_invite_link.url"
            target="_blank"
            class="link-underline clr-primary"
            v-html="'Discord'"
          >
          </a>

          <div
            v-if="localDiscordTag && updatedInSession"
            class="f-center"
          >
            <v-icon
              size="large"
              color="primary"
              class="mr-4 mb-auto"
              >mdi-checkbox-marked-circle-outline</v-icon
            >
            <div class="text-left">
              {{ $t('subscription.activate_shortly_discord_title') }}
              <a
                style="font-size: 12px; white-space: nowrap"
                :href="links_url_links.discord_invite_link.url"
                target="_blank"
                class="link-underline clr-primary"
              >
                {{ $t('messages.remeber_to_join_discord') }}
              </a>
            </div>
          </div>
          <span
            v-if="canUpdate"
            class="discord-box_activated-title"
          >
            {{ $t('subscription.update_discord_title') }}
            <a
              style="font-size: 12px; white-space: nowrap"
              :href="links_url_links.discord_invite_link.url"
              class="link-underline clr-primary"
            >
              {{ $t('messages.remeber_to_join_discord') }}
            </a>
          </span>
        </div>
      </div>
      <div
        v-if="localDiscordTag && !updatedInSession"
        class="discord-box_activated-tag"
        @click="updateTag"
      >
        {{ localDiscordTag }}
        <v-btn
          icon
          class="ml-2"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </div>
      <GwInput
        v-if="!localDiscordTag && !nadaPurchased"
        :placeholder="$t('subscription.placeholder_discord_tag01')"
        type="text"
        class="my-2"
        :autofocus="false"
        :getErrors="() => errors"
        :value="inputValue"
        @input="(_e, value) => (inputValue = value)"
      />
      <div
        v-if="nadaPurchased"
        class="discord-box_onlyusers"
      >
        {{ $t('subscription.only_for_subscribed_users_0') }}
        <router-link
          to="/subscription"
          class="link-underline link-underline_current-color"
        >
          {{ $t('subscription.only_for_subscribed_users_1') }}
        </router-link>
      </div>
    </div>
    <v-btn
      v-if="!localDiscordTag && !nadaPurchased"
      :size="compact ? 'small' : 'large'"
      :color="localDiscordTag ? '' : 'primary'"
      :loading="updateCall.loading"
      class="discord-box_btn mt-2"
      @click="saveTag"
    >
      <span v-if="!discord_tag"> {{ $t('btn.activate') }} </span>
      <span v-else> {{ $t('btn.update') }} </span>
    </v-btn>

    <slot />
  </div>
</template>

<script>
import { gtm_sub_discord } from '@/helpers/gtm'
import { seg_track } from '@/helpers/segment'

import TooltipUnderline from '@/components/Payments/TooltipUnderline'
import tier_mix from '@/mixins/tier_mix'
import links_mix from '@/mixins/links_mix'
import GwInput from '@/components/lib/GwInput'

export default {
  name: 'DiscordBox',

  components: {
    TooltipUnderline,
    GwInput,
  },
  mixins: [tier_mix, links_mix],
  props: {
    person: String,
    text: String,
    compact: Boolean,
  },
  data() {
    return {
      canUpdate: false,
      updatedInSession: false,

      inputValue: '',
      errors: [],
      localDiscordTag: '',
    }
  },
  mounted() {
    this.inputValue = this.discord_tag || ''
  },
  methods: {
    saveTag() {
      if (this.discord_tag && this.discord_tag === this.inputValue) return
      this.errors = []
      this.inputValue = this.inputValue.trim()
      if (!this.inputValue.length) {
        this.errors = [this.$t('errors.discord_input_empty')]
        return
      }
      // let valid = /^.{2,32}#[0-9]{4}$/.test(this.inputValue)
      // if (!valid) {
      //   this.errors = [
      //     this.$t('errors.discord_input_invalid'),
      //   ]
      //   this.$refs.input.focus()
      //   this.$refs.input.$el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'end' })
      //   return
      // }
      if (this.updateCall.loading) return
      this.updatedInSession = true
      this.canUpdate = false

      if (!this.discord_tag) {
        gtm_sub_discord()
        seg_track('discord_subscriber_role_activated', {})
      }

      this.$store.dispatch('account_settings_patch', {
        data: {
          discord_tag: this.inputValue,
        },
      })
    },
    updateTag() {
      this.canUpdate = true
      this.updatedInSession = true
      this.localDiscordTag = ''
      this.inputValue = ''
    },
    setLocalTag() {
      this.localDiscordTag = this.discord_tag || ''
    },
  },
  computed: {
    discord_tag() {
      const apiData = this.$store.getters.api_get_data('api_account_settings') || {}
      return apiData?.discord_tag
    },
    updateCall() {
      const res = this.$store.getters.api_get('api_account_settings')
      return res
    },
    mdAndDown() {
      const { globals_mobile } = this.$store.getters
      return globals_mobile
    },
    smallScreen() {
      const { globals_window_size } = this.$store.getters
      return globals_window_size.width < 768
    },
  },
  watch: {
    discord_tag: {
      immediate: 'true',
      handler: 'setLocalTag',
    },
  },
}
</script>

<style lang="scss" scoped>
@media (max-width: 1023px) {
  .discord-box {
    &_input {
      max-width: unset !important;
    }
  }
}

.tier-tag {
  &_starter {
    color: var(--clr-blue);
  }
  &_premium {
    color: var(--clr-yellow);
  }
  &_icon {
    color: currentColor;
  }
}

.discord-box {
  width: 28rem;
  max-width: calc(100vw - 2rem);
  padding: 2rem 2rem;
  background: var(--clr-black-1);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  &_icon {
    font-size: 2rem !important;
    margin-right: 1rem;
  }
  &_input {
    margin-top: 2rem;
  }
  &_header {
    display: flex;
  }
  &_subtitle {
    font-size: 1.5rem;
    font-weight: 700;
  }
  &_text {
    font-size: 1rem;
    font-weight: 500;
    text-align: left;
    padding-top: 0.5rem;
  }
  &_content {
    display: flex;
    flex-direction: column;
  }
  &_onlyusers {
    padding: 0.5rem 0;
    color: var(--clr-error);
    font-weight: 500;
    text-align: left;
  }
}

.discord-box-compact {
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0;
  background: none;
  max-width: 24rem !important;
  .discord-box {
    &_input {
      margin-top: 0.25rem;
      max-width: 16rem;
    }
    &_text {
      font-size: 1rem;
      font-weight: 400;
      padding: 0 !important;
    }
    &_icon {
      margin-bottom: 0;
      display: none;
      font-size: 1.5rem !important;
      margin-right: 0.5rem;
    }
    &_header {
      display: flex;
    }
    &_activated-tag {
      position: relative;
      top: -4px;
    }
  }
}
</style>
